import { DefaultError } from '@tanstack/query-core';
import { NavigateFunction } from 'react-router';
import { CommonResponse } from '@/common/api/types';

export const catchError = async (response: Response) => {
  if (!response.ok) {
    localStorage.clear();
    throw new Error('Что-то пошло не так');
  }
};

type CustomErrorHandler = ({
  token,
  isFetched,
  response,
  error,
  catchError,
  navigate,
}: {
  token: string | null;
  isFetched: boolean;
  response: any;
  error: DefaultError | null;
  catchError: (response?: CommonResponse, error?: any) => void;
  navigate: NavigateFunction;
}) => void;

export const customErrorHandler: CustomErrorHandler = ({
  token,
  isFetched,
  response,
  error,
  catchError,
  navigate,
}) => {
  if (token && isFetched && !response) {
    setTimeout(() => {
      localStorage.clear();
      navigate('/auth');
    });
  }

  if ((response && !response?.success) || error) {
    setTimeout(() => catchError(response, error));
  }
};
